import React, { useEffect, useState } from 'react'
import { Avatar, Spin, Typography } from 'antd'
import { AppDispatch, RootState } from '../../../redux/store/store';
import { useDispatch, useSelector } from 'react-redux';
import { fetchChatConversaciones, setConversacionSeleccionadaAction, setNuevaConversacionAction, setUpdateLastMessageAction } from '../../../redux/actions/chat/conversaciones/Conversaciones';
import { socket } from '../../../utils/services/socket';
import { formatTimeAgo } from '../../../utils/formatTime/FormatTimeAgo';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
  LoadingOutlined,
} from '@ant-design/icons';

interface ChatConversacionesListProps {
}

const ChatConversacionesList: React.FC<ChatConversacionesListProps> = ({ }) => {

  const dispatch = useDispatch<AppDispatch>();

  const { Text } = Typography;

  const {
    conversacion_seleccionada,
    chat_conversaciones,
    pagination
  } = useSelector((state: RootState) => state.conversaciones);

  const [page, setPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);

  const { rex_user } = useSelector((state: RootState) => state.login);

  const getData = async (page = 1) => {
    await dispatch(fetchChatConversaciones(page, pagination.limit))
  }

  const fetchMoreData = async () => {
    setLoadingMore(true)
    const nextPage = page + 1;
    setPage(nextPage);
    await getData(nextPage)
    setLoadingMore(false)
  }

  const onClickItem = (conversation: any) => {
    if(conversacion_seleccionada?.user.id != conversation.user.id){
      dispatch(setConversacionSeleccionadaAction(conversation))
    }
    if (conversacion_seleccionada?.id && conversacion_seleccionada.id != conversation.id) {
      socket.emit('leaveConversation', {
        conversationId: conversacion_seleccionada.id
      })
    }
  }

  useEffect(() => {

    socket.on('newConversationEvent', (conversation) => {
      dispatch(setNuevaConversacionAction(conversation))
    });

    socket.on('updateLastMessageEvent', (msg) => {
      dispatch(setUpdateLastMessageAction(msg))
    });

    return () => {
      socket.off('updateLastMessageEvent');
      socket.off('newConversationEvent');
    };
  }, [])

  useEffect(() => {
    getData()
  }, [])

  return (
    <div className="py-2 relative">
      <h5 className="text-primary my-2 mx-3">Chats</h5>
      <div
        style={{
          height: '70vh',
          overflowY: 'scroll',
        }}
      >
        {/* <InfiniteScroll
          dataLength={pagination.total}
          next={fetchMoreData}
          style={{
            height:'70vh'
          }}
          hasMore={(chat_conversaciones.length ?? 0) < pagination.total}
          loader={
            <div className='w-full mt-2 flex justify-center'>
              <Spin size="large" indicator={<LoadingOutlined spin />} />
            </div>
          }

        > */}
          {chat_conversaciones.length > 0 && chat_conversaciones.map((conversation, index) => (
            <div
              key={index}
              className={`py-3 pl-3 pr-1 rounded-lg cursor-pointer ${conversation.user.id == conversacion_seleccionada?.user.id ? 'bg-blue-100':'hover:bg-gray-100'}`}
              onClick={() => onClickItem(conversation)}
            >
              <div className="flex gap-2 items-center">
                <div className='w-[35px]'>
                  <Avatar src={conversation?.user?.imagen_perfil} className="h-8 w-8" />
                </div>
                <div className={`w-full ${(!conversation?.mensaje?.leido && rex_user.id != conversation?.mensaje?.emisorId) && 'font-bold'}`}>
                  <div className='relative'>
                    <div className="font-normal">
                      <Text
                        style={{ width: 120 }}
                        ellipsis={{ tooltip: `${(conversation?.user?.personas?.nombre ?? '') + ' ' + (conversation?.user?.personas?.apellidos ?? '')}` }}
                      >
                        {(conversation?.user?.personas?.nombre ?? '') + ' ' + (conversation?.user?.personas?.apellidos ?? '')}
                      </Text>
                    </div>
                    <div className={`absolute top-0 px-1 text-gray-500 
                      ${(!conversation?.mensaje?.leido && rex_user.id != conversation?.mensaje?.emisorId) ? 'right-5' : 'right-0'}`}
                    >
                      <small>{conversation.mensaje ? formatTimeAgo(conversation.mensaje.createdAt) : ''}</small>
                    </div>
                    {
                      (!conversation?.mensaje?.leido && rex_user.id != conversation?.mensaje?.emisorId && conversation.id)
                        ? <div className='absolute top-[6px] right-0 px-1 text-gray-500'>
                          <div className='w-3 h-3 bg-blue-500 rounded-md'></div>
                        </div>
                        : null
                    }
                  </div>
                  <div className='mt-1'>
                    <small className={`text-gray-500 ${!conversation.mensaje ? 'italic' : ''} block`}>
                      {conversation?.mensaje?.contenido || 'Iniciar chat'}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          ))}
        {/* </InfiniteScroll> */}
        {
          chat_conversaciones.length > 0 && (chat_conversaciones.length < pagination.total)
            ? <div className='flex justify-center py-2'>
              <button
                className='btn btn-primary !py-1 w-[122px]'
                onClick={fetchMoreData}
              >{loadingMore ? 'Cargando' : 'Cargar mas'}</button>
            </div>
            : null
        }
      </div>
    </div>
  )
}

export default ChatConversacionesList